import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useCanvasOffscreen } from '../CanvasOffscreen/canvas-offscreen.js';

const Canvas = () => {
  var _a;
  const theme = useLlm(state => state.theme);
  const ref = useRef(null);
  useCanvasOffscreen(ref);
  if (!((_a = theme.canvas) === null || _a === void 0 ? void 0 : _a.enabled)) {
    return;
  }
  return jsx("canvas", {
    className: "llm__canvas",
    ref: ref,
    "aria-hidden": true
  });
};

export { Canvas };
//# sourceMappingURL=canvas.js.map
